<template>
  <div class="text-xs-center">
    <v-pagination
      v-model="currentPage"
      :length="pages ? pages : 1"
      :total-visible="rowPerPage > MAX_VISIBLE_ITEMS ? MAX_VISIBLE_ITEMS : rowPerPage"
      @input="onPageChange"
    />
  </div>
</template>

<script>

export default {
  props: {
    total: {
      type: Number,
      default: () => { return 1 }
    },
    rowPerPage: {
      type: Number,
      default: () => { return 1 }
    }
  },
  data: () => ({
    MAX_VISIBLE_ITEMS: 7,
    currentPage: 1
  }),

  computed: {
    pages () {
      if (this.rowPerPage == null || this.total == null) {
        return 0
      }
      return this.total
    }
  },
  methods: {
    onPageChange: function () {
      this.$emit('onPageChange', this.currentPage)
    }
  }
}
</script>
